import axios from 'axios';
import store from '@/store'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import notification from 'ant-design-vue/es/notification'
import router from '@/router'

/**
 * 【指定 axios的 baseURL】
 * 如果手工指定 baseURL: '/api'
 * 则映射后端域名，通过 vue.config.js
 * @type {*|string}
 */
// let apiBaseUrl = process.env.NODE_ENV == 'development' ? '/public' : window._CONFIG['domianURL'];
let apiBaseUrl = process.env.VUE_APP_API_BASE_URL || "/api";
//console.log("apiBaseUrl:",apiBaseUrl);

// 全局的axios默认值
const Instance = axios.create({
  baseURL: apiBaseUrl,
  timeout: 20000, // 请求超时时间
  withCredentials: false
});

const loginRoutePath = '/login'

// 添加请求拦截器
Instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  const token = storage.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Access-Token'] = token;
  }
  return config;
}, errorHandler);

// 添加响应拦截器
Instance.interceptors.response.use(response => {
  // 对响应数据做点什么
  const data = response.data 
  // 请求成功，直接返回
  if (data.code === 0) {
    return data
  }
  // 服务端返回的参数校验失败统一处理
  if (data.code === 422) {
    const err = []
    for (const key in data.data) {
      err.push(data.data[key])
    }
    notification.error({
      message: data.msg || '参数校验失败',
      description: err.length > 0 ? err.join('\n') : '参数校验失败',
    })
    return data
  }
  // 返回登陆信息已失效的处理
  if (data.code === 401 || data.code === 402) {
    storage.remove(ACCESS_TOKEN)
    notification.error({
      message: '登陆失效',
      description: data.msg || '登录信息已失效',
    })
	
    if (router.currentRoute.name !== 'login') {
      router.push({ path: loginRoutePath })
      return data
    }
    return data
  }
  // 返回权限不足的 code 处理
  if (data.code === 403) {
    notification.error({
      message: '权限不足',
      description: data.msg || '当前用户权限不足',
    })
    return data
  }
  if (data.code === -1) {
    notification.error({
      message: '提示',
      description: data.msg,
    })
    return data
  }
  // 其他 code != 0 的通用处理
  // notification.error({
  //   message: '出错提示',
  //   description: data.msg || '对不起，访问出错了！',
  // })
  return data
}, errorHandler)

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 500) {
      notification.error({
        message: '接口错误',
        description: '请联系管理员处理！',
      })
      return
    }
    if (error.response.status === 403) {
      notification.error({
        message: '禁止访问',
        description: data.message,
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: '未经授权',
        description: '授权验证失败',
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
    notification.error({
      message: '其它错误',
      description: '请刷新页面或联系管理员处理！',
    })
  }else {
    notification.error({
      message: '其它错误',
      description: '接口没有响应，请联系管理员处理！',
    })
  }

  return Promise.reject(error)
}


export default Instance;